
import React, { PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './ThemeProvider'
import ErrorBoundary from './ErrorBoundary'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/toaster'
import { AuthProvider } from '@/hooks/useAuth'
import { I18nextProvider } from 'react-i18next'
import i18n from '@/lib/i18n'
import { TranslationEditProvider } from '@/contexts/TranslationEditContext'
import { FeatureFlagsProvider } from '@/contexts/FeatureFlagsContext'
import { PlanSelectDialogProvider } from '@/contexts/PlanSelectDialogContext'
import { WorkspaceProvider } from '@/contexts/WorkspaceContext'
import { EulaAcceptanceModal } from '@/components/auth/EulaAcceptanceModal'
import { WorkspaceSwitchingOverlay } from '@/components/workspace/WorkspaceSwitchingOverlay'
import { EnvironmentSetupScreen } from '@/components/setup-guide/EnvironmentSetupScreen'
import { ImpersonationBanner } from '@/components/layout/ImpersonationBanner'

import { queryClient } from '@/hooks/subscriptions/queryClient'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <I18nextProvider i18n={i18n}>
              <AuthProvider>
                <WorkspaceProvider>
                  <FeatureFlagsProvider>
                    <TranslationEditProvider>
                      <PlanSelectDialogProvider>
                        <ImpersonationBanner />
                        <WorkspaceSwitchingOverlay />
                        {children}
                        <EulaAcceptanceModal />
                        <EnvironmentSetupScreen />
                        <Toaster />
                      </PlanSelectDialogProvider>
                    </TranslationEditProvider>
                  </FeatureFlagsProvider>
                </WorkspaceProvider>
              </AuthProvider>
            </I18nextProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}
